/**
 * The guardrail message's markdown (mailto links, apostrophes, brackets) can
 * match Cloud Armor's OWASP CRS signatures on `PUT /globalConfig` and get the
 * whole save rejected before it reaches the backend. Base64-encode it so no
 * risky literal characters appear in the request body; the backend decodes
 * `veraGuardrailMessageBase64` back to text (see
 * ../../investment-management-backend/docs/STAGING_403_VERA_GLOBAL_CHAT.md
 * for the same class of false positive).
 */
export function encodeVeraGuardrailMessageBase64(text: string): string {
  const bytes = new TextEncoder().encode(text);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
}
